import { render, staticRenderFns } from "./qr-code.vue?vue&type=template&id=8f3c59e2&lang=pug&"
import script from "./qr-code.vue?vue&type=script&lang=js&"
export * from "./qr-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports